// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2zCSK","title":"BackImages_title__vXphM","images":"BackImages_images__iFVLX"};